import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const EngineOilIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M9.33771 10.35L10.4139 11.426V13.4255L9.33771 14.5016L10.2293 15.3931L11.3055 14.317H13.3047L14.3809 15.3931L15.2725 14.5016L14.1963 13.4254V11.4261L15.2725 10.35L14.3809 9.45844L13.3048 10.5345H11.3054L10.2293 9.45844L9.33771 10.35ZM11.6539 11.7745H12.9563V13.0769H11.6539V11.7745ZM8.78387 4.49152L7.89239 3.6001L6.00122 5.49127L6.89264 6.38269L8.78388 4.49152H8.78387ZM10.414 4.23047L6.63159 8.01288V19.36H17.9788V4.23048H10.414V4.23047ZM16.3088 17.6901H8.30164V8.7046L11.1058 5.90046H16.3088V17.6901V17.6901Z" />
    </SvgIcon>
  );
});
